/**
 * Currently used IAB categories and CATTAX values
 */
export const IAB_CATTAX = 6;
export const IAB_UNMODERATED_UGC_CATEGORY = "1217";
export const IAB_BSR_DEFAULT_LOW_RISK_CATEGORY = "bsr004";
export const IAB_ENTERTAINMENT_CONTENT_CATEGORY = "1014";

export const MAX_VALUE_LENGTH = 40;
export const MAX_NUMBER_OF_VALUES = 50;

export type TaxonomyKeysConfiguration = {
  from: string;
  addConfidence?: "site" | "page" | "all"; // default value prevents confidence from being added at all
  limit?: "one-of-each"; // defaults to no limit; limit of `one-of-each` means one value will be taken from the 'site' AND 'page' keys
};

export const TAXONOMY_NEW_KEYS_CONFIGURATION: Record<
  string,
  TaxonomyKeysConfiguration
> = {
  main_vertical: {
    from: "main_vertical",
    limit: "one-of-each",
  },
  main_entity_type: {
    from: "main_entity_type",
    limit: "one-of-each",
  },
  genre: {
    from: "genres",
    addConfidence: "site",
  },
  subgenre: {
    from: "subgenres",
    addConfidence: "site",
  },
  vertical: {
    from: "verticals",
    addConfidence: "all",
  },
  themes: {
    from: "themes",
    addConfidence: "site",
  },
  fran: {
    from: "franchises",
  },
};
